import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2e09b43a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "catalog-service-accordeon" };
const _hoisted_2 = { class: "block text-600 font-bold my-3" };
const _hoisted_3 = { class: "catalog-service-accordeon-header" };
const _hoisted_4 = { class: "catalog-service-accordeon-header-text" };
const _hoisted_5 = { class: "catalog-service-accordeon-header-arrow" };
const _hoisted_6 = {
    key: 0,
    class: "pi pi-chevron-up",
    style: { "color": "var(--cyan-400)" }
};
const _hoisted_7 = {
    key: 1,
    class: "pi pi-chevron-down",
    style: { "color": "var(--cyan-400)" }
};
const _hoisted_8 = { class: "grid mx-2" };
import { ref } from "vue";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import CatalogServiceCard from "@/components/templates/Catalog/CatalogServiceCard.vue";
import ImageWithNoImageDefault from "@/components/atoms/ImageWithNoImageDefault.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CatalogServiceAccordeon',
    props: {
        data: {}
    },
    setup(__props) {
        const { data } = __props;
        const activeIndex = ref([]);
        const tabOpen = (event) => {
            activeIndex.value.push(event.index);
        };
        const tabClose = (event) => {
            activeIndex.value = activeIndex.value.filter((element) => element !== event.index);
        };
        const isopen = (index) => {
            return activeIndex.value.includes(index);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.data.title.toUpperCase()), 1),
                _createVNode(_unref(Accordion), {
                    multiple: true,
                    onTabOpen: tabOpen,
                    onTabClose: tabClose
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.categories, (category, index) => {
                            return (_openBlock(), _createBlock(_unref(AccordionTab), { key: index }, {
                                header: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_3, [
                                        (category.pictureUri)
                                            ? (_openBlock(), _createBlock(ImageWithNoImageDefault, {
                                                key: 0,
                                                source: category.pictureUri,
                                                class: "category-icon"
                                            }, null, 8, ["source"]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", {
                                            class: "catalog-service-accordeon-header-color",
                                            style: _normalizeStyle({ backgroundColor: category.backgroundColorHex })
                                        }, null, 4),
                                        _createElementVNode("div", _hoisted_4, _toDisplayString(category.title), 1),
                                        _createElementVNode("div", _hoisted_5, [
                                            (isopen(index))
                                                ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                                                : (_openBlock(), _createElementBlock("i", _hoisted_7))
                                        ])
                                    ])
                                ]),
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_8, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.cards, (card) => {
                                            return (_openBlock(), _createBlock(CatalogServiceCard, {
                                                "data-test": "catalog-service-card",
                                                style: { "margin-top": "20px" },
                                                class: "col-12 md:col-6 lg:col-4",
                                                key: card.id,
                                                data: card
                                            }, null, 8, ["data"]));
                                        }), 128))
                                    ])
                                ]),
                                _: 2
                            }, 1024));
                        }), 128))
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
